import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGarage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconGarage"><Path fillRule="evenodd" clipRule="evenodd" d="M11.6343 3.09522C11.8616 2.96826 12.1384 2.96826 12.3657 3.09522L21.6157 8.26189C21.853 8.39441 22 8.64491 22 8.91667V19.25C22 19.6642 21.6642 20 21.25 20H2.75C2.33579 20 2 19.6642 2 19.25V8.91667C2 8.64491 2.14701 8.39441 2.38427 8.26189L11.6343 3.09522ZM7.5 18.5H16.5V16H7.5V18.5ZM7.5 14.5H16.5V12H7.5V14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGarage;
